import { call, put, takeLatest } from 'redux-saga/effects';
import { SubscriptionDetailPageActions as actions } from '.';
import { Subscription } from 'types/models';
import fetchClient from 'utils/requestInterceptor';
import { API_ENDPOINTS } from 'utils/configs';
import { PayloadAction } from '@reduxjs/toolkit';
import { UpdateSubscriptionAction } from './types';
import {
  displayError,
  displaySuccessToaster,
} from 'app/components/ToasterBar/helpers';
import { SubscriptionToasterMsg } from 'app/components/ToasterBar/constants';

export function* fetchSubscription(action: PayloadAction<string>) {
  try {
    const { data }: { data: Subscription } = yield call(
      fetchClient.get,
      API_ENDPOINTS.SUBSCRIPTION + action.payload,
    );
    yield put(actions.fetchSubscriptionSucceed(data));
  } catch (err) {
    yield put(actions.fetchSubscriptionFailed());
    yield call(displayError, err);
  }
}

export function* updateSubscription(
  action: PayloadAction<UpdateSubscriptionAction>,
) {
  try {
    const { data }: { data: Subscription } = yield call(
      fetchClient.put,
      API_ENDPOINTS.SUBSCRIPTION + action.payload.id,
      action.payload.updatedSubscription,
    );

    yield put(actions.updateSubscriptionSucceeded(data));
    yield call(
      displaySuccessToaster,
      SubscriptionToasterMsg.UPDATE_SUBSCRIPTION_SUCCEED,
    );
  } catch (err) {
    yield call(displayError, err);
  }
}

export function* SubscriptionDetailPageSaga() {
  yield takeLatest(actions.fetchSubscription.type, fetchSubscription);
  yield takeLatest(actions.updateSubscription.type, updateSubscription);
}
